import Conta from './Conta';
import ContaConfig from './contaConfig';

export default Conta;

export { ContaConfig };
